module.exports = {"370684001":"登州街道","370684002":"紫荆山街道","370684003":"新港街道","370684004":"蓬莱阁街道","370684005":"南王街道","370684102":"刘家沟镇","370684103":"潮水镇","370684105":"大柳行镇","370684106":"小门家镇","370684107":"大辛店镇","370684108":"村里集镇","370684109":"北沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370684.json
// module id = 1526
// module chunks = 0